import React from 'react';
import { ICharacterMapFeed } from '@pvplevelup/core/dist/queries/character/character';
import { ProfileMaps } from 'components/Profile/ProfileMaps';

interface Props {
  mapFeed: ICharacterMapFeed | undefined;
  fetchMoreRecords: ()=>void;
}

/** The character page's Maps tab. */
const CharacterMaps: React.FC<Props> = ({mapFeed,fetchMoreRecords}) => {
  return <ProfileMaps mapFeed={mapFeed} fetchMoreRecords={fetchMoreRecords} />;
};

export {CharacterMaps};
